export default __webpack_public_path__ + "static/media/mainpic3.6380deb1.png";